import { Stack, Typography } from '@mui/material'
import { HoldRestrictionSummaryDto, OperationType } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { HoldsIcon, Tile, useMinimalsTheme } from '@tom-ui/ui'

interface Props {
  operationType?: OperationType
  entryHoldRestriction?: HoldRestrictionSummaryDto | null
  exitHoldRestriction?: HoldRestrictionSummaryDto | null
  yardHoldRestriction?: HoldRestrictionSummaryDto | null
}

const collectApplicable = ({
  operationType,
  entryHoldRestriction,
  exitHoldRestriction,
  yardHoldRestriction,
}: Props): HoldRestrictionSummaryDto[] => {
  const applicable: HoldRestrictionSummaryDto[] = []
  if (operationType === OperationType.Inbound && entryHoldRestriction)
    applicable.push(entryHoldRestriction)
  if (operationType === OperationType.Outbound && exitHoldRestriction)
    applicable.push(exitHoldRestriction)
  if (yardHoldRestriction) applicable.push(yardHoldRestriction)
  return applicable
}

export const hasApplicableHold = (props: Props): boolean => collectApplicable(props).length > 0

export const getApplicableHoldTypeNames = (props: Props): string[] => [
  ...new Set(collectApplicable(props).flatMap(r => r.holdTypeNames)),
]

export const HoldIndicator = (props: Props) => {
  const theme = useMinimalsTheme()
  const names = getApplicableHoldTypeNames(props)
  if (names.length === 0) return null
  return (
    <Stack
      flexDirection='row'
      alignItems='center'
      gap={theme.customSpacing.xs}
      data-cy='job-card-hold-indicator'
    >
      <HoldsIcon />
      <Typography variant='body2'>{names.join(', ')}</Typography>
    </Stack>
  )
}

export const HoldField = (props: Props) => {
  const { t } = useTranslate()
  const names = getApplicableHoldTypeNames(props)
  if (names.length === 0) return null
  return <Tile nowrap label={t('hold', 'Hold')} value={names.join(', ')} />
}
